import { ConnectVehicleDto, UserVehicleDto, VehicleInformationDto } from '../dto'
import { ConnectVehicle, UserVehicle, VehicleInformationModel } from '../models'
import { ManufacturerState, VehicleModel } from '../types'

/**
 * transform fetched user vehicles to user vehicles model
 */
export const transformUserVehiclesDtoToModel = (dto: UserVehicleDto[]): UserVehicle[] => {
  return dto.map(vehicle => ({
    batteryCapacity: vehicle.batteryCapacity ?? undefined,
    calculatedBatteryCapacity: vehicle.calculatedBatteryCapacity ?? undefined,
    externalId: vehicle.externalId,
    id: vehicle.id,
    manufacturer: vehicle.manufacturer ?? undefined,
    model: (vehicle.model as VehicleModel) ?? undefined,
    name: vehicle.vehicleName,
    variant: vehicle.vehicleVariant ?? undefined,
    vendorId: vehicle.vendorId,
    isConnectedToMultipleInstallations: vehicle.isConnectedToMultipleInstallations,
    vendorState: vehicle.vendorState ?? ManufacturerState.available,
    ehaExternalId: vehicle.ehaExternalId,
    vin: vehicle.vin,
    disconnectedAt: vehicle.disconnectedAt ?? null,
    customName: vehicle.customName ?? null,
    hasCustomImage: vehicle.hasCustomImage,
    activeSchedule: vehicle.activeSchedule ?? undefined,
    targetStateOfCharge: vehicle.targetStateOfCharge ?? undefined,
  }))
}

export const transformConnectVehiclesDtoToModel = (dto: ConnectVehicleDto[]): ConnectVehicle[] => {
  return dto.map(vehicle => ({
    id: vehicle.externalId,
    isLinked: vehicle.isLinked,
    manufacturer: vehicle.vendor,
    name: vehicle.vehicleName,
    vin: vehicle.vin,
    externalId: vehicle.externalId,
  }))
}

export const transformVehicleInformationDtoToModel = (dto: VehicleInformationDto): VehicleInformationModel => {
  return {
    id: dto.id,
    stateOfCharge: dto.stateOfCharge,
    chargeLimitMin: dto.chargeLimitMin ?? undefined,
    chargingTimeRemaining: dto.chargingTimeRemaining,
    estimatedRange: dto.estimatedRange,
    chargingState: dto.chargingState,
    vehicleId: dto.vehicleId,
    isOnline: dto.isOnline,
    prevChargingState: dto.prevChargingState ?? undefined,
    chargeRate: dto.chargeRate,
    isClimateOn: dto.isClimateOn,
    lastUpdatedLocation: new Date(dto.lastUpdatedLocation),
    lastUpdatedStateOfCharge: new Date(dto.lastUpdatedStateOfCharge),
    latitude: Number(dto.latitude),
    longitude: Number(dto.longitude),
    odometer: dto.odometer,
    temperatureTarget: Number(dto.temperatureTarget),
    vendorState: dto.vendorState,
    chargeLimitMax: dto.chargeLimitMax ?? undefined,
    isBatteryHeaderOn: dto.isBatteryHeaterOn ?? undefined,
    scheduledChargingStartTime: dto.scheduledChargingStartTime ? new Date(dto.scheduledChargingStartTime) : undefined,
    scheduledDepartureTime: dto.scheduledDepartureTime ? new Date(dto.scheduledDepartureTime) : undefined,
    temperatureCurrent: dto.temperatureCurrent === null ? undefined : Number(dto.temperatureCurrent),
    hasError: dto.hasError,
  }
}
